import React, {useEffect, useCallback, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {logPageLoadEvents} from '@ibibo/analytics';
import {Helmet} from 'react-helmet';

import {
  userSettingDataSelector,
  setUserSetting,
  supportInfoDataSelector,
  profileInfoSelector,
  popupInfoSelector,
  userWalletInfoSelector,
} from '@ibibo/myaccount-reducer';

import * as S from './Settings.styles';

import LeftBlock from './LeftBlock/LeftBlock';
import RightBlock from './RightBlock/RightBlock';
import LoyalityAgreement from '../LoyalityAgreement/LoyalityAgreement';

import RightBlockGcc from './RightBlockGcc/RightBlockGcc';

import PopUp from '../../../../../onboarding/src/stories/components/UI/Popup/Popup';
import {getTerms} from '../../../../../onboarding/src/store/actions/thunk';
import Header from './Header/Header';
import CommonModal from './../CommonModal/CommonModal';
import KycExpiryModal from './../KycExpiryModal/KycExpiryModal';
import PopUp1 from './../../../../../onboarding/src/stories/components/OnboardingNew/PopUp/Popup';
import DocUploadMpdal from './../DocUploadModal';
import {StatusPopup} from './../StatusPopup';
import {submitLicenseDetails} from '@ibibo/myaccount-reducer';
import {redirectToSameWindowWithoutRefresh, getCrid} from '../../../utils/redirectWithCrId';
import {getCookie} from './../../../utils/getCookie';
import {useAnalyticService} from '@ibibo/analytics-provider';

const Settings = () => {
  const crId = getCrid();
  if (!crId) {
    redirectToSameWindowWithoutRefresh(`/mysettings`);
  }
  const {updateAnalyticDataStore, sendTrackingDataToSdk} = useAnalyticService();
  const dispatch = useDispatch();
  const popupInfo = useSelector(popupInfoSelector);
  const userData = useSelector(userSettingDataSelector);
  const walletInfo = useSelector(userWalletInfoSelector);
  const [showPop, setShowPop] = useState(false);
  const [userConsent, setUserConsent] = useState(null);
  const [userAgree, setUserAgree] = useState('');
  const [newPolicy, setNewPolicy] = useState(false);
  const [showLoyaltyAgreementFlag, setLoyaltyAgreementFlag] = useState(false);

  const [popupContent, updatePopupContent] = useState(null);
  const supportDetails = useSelector(supportInfoDataSelector);

  /******************** state section for doc upload ********************/
  const [isDocUploadLoading, updateDocUploadLoading] = useState(false);
  const [disabledInputForDoc, updateDisabledInputForDoc] = useState(false);
  const [fileData, setFileData] = useState(null);
  const [trnNumber, setTrnNumber] = useState('');
  const [docUploadResponse, setResponseData] = useState(null);
  const [licenseNumber, setLicenseNumber] = useState('');
  const [approve, setApprove] = useState(false);
  const [disableSubmitButton, setDisableSubmitButton] = useState(true);

  const [busineesDetails, setBusinessDetails] = useState({
    business_name: '',
    expiry_date: '',
    address: '',
    business_desc: '',
  });
  // const [licenseNumberResponse, setLicenseNumberResponse] = useState({});
  const [docUploadErr, updateDocUploadErr] = useState({});
  const [trnLoader, setTrnLoader] = useState(false);
  /******************* END of state section for doc upload *******************/

  useEffect(() => {
    logPageLoadEvents('mysettings:myprofile', {});
  }, []);
  const loadPDTTrackingData = ({userData, walletInfo}) => {
    const {account_id, is_sub_user, uuid} = userData;

    const pdtTrackingData = {
      global: {
        payload: {
          campaign_details: {
            campaign_name: 'mypartner_direct',
            campaign_key: 'MYPARTNER',
          },
          event_tracking_context: {
            traffic_source: 'mypartner_direct',
            domain_country: 'india',
            domain_currency: 'INR',
            domain_language: 'eng',
            env: 'prod',
            bu: 'mypartner_core',
            organisation: 'MMT',
            funnel_source: 'mypartner_core',
            topic_name: 'mmt_core_mypartner_pdt_client_logging',
            producer: 'mypartner_core',
            template_id: 179775,
          },
          user_context: {
            user_type: is_sub_user ? 'Sub User' : 'Admin',
            agency_code: account_id?.value,
            profile_type: 'cta',
            uuid: uuid?.value || '',
            is_logged_in: true,
            logging_channel: null,
            wallet_bal: walletInfo?.tb,
          },
        },
      },
      pageLoad: {
        payload: {
          page_context: {
            lob: 'common',
            lob_category: 'common',
            page_title: null,
            page_name: 'myprofile',
            subpage_name: null,
            site_section: null,
            page_type: 'landing',
            percent_page_viewed: null,
            prev_page_name: null,
            travel_store: null,
            page_url: null,
            funnel_step: 'landing',
            page_state_journey: null,
            sub_lob: 'mypartner_core',
            pg_time_interval: null,
            platform: null,
          },
          coupon_details: null,
          cross_sell_details: null,
          addon_details: null,
          traveller_details_list: null,
          payment_details: null,
          campaign_details: null,
          event_detail: {
            event_name: 'page_entry',
            event_type: 'user_action',
            event_value: 'myprofile',
            components: null,
            client_travel_store_meta: null,
            interaction_type: null,
            booking_info: null,
          },
        },
      },
    };
    if (pdtTrackingData) {
      updateAnalyticDataStore?.(pdtTrackingData, 'PROFILE');
      sendTrackingDataToSdk?.(pdtTrackingData, 'PROFILE');
    }
  };
  useEffect(() => {
    setLoyaltyAgreementFlag(userData?.tnc_completed?.show_agreement);
    if (userData) {
      loadPDTTrackingData({userData, walletInfo});
    }
  }, [userData]);

  useEffect(() => {
    if (userData.tnc_completed) {
      if (!userData.tnc_completed.value) {
        setShowPop(true);
        setNewPolicy(true);
        dispatch(getTerms('', successCallback, errorCallback));
      }
    }
  }, [userData]);

  useEffect(() => {
    let flag = false;
    for (const key in busineesDetails) {
      if (key !== 'trn_number' && busineesDetails[key] === '') {
        flag = true;
      }
    }

    if (flag === true) {
      setDisableSubmitButton(true);
    } else setDisableSubmitButton(false);
  }, [busineesDetails]);

  const ccdeCookie = getCookie('ccde');
  const indianUserFlag = getCookie('ccde') !== 'AE' ? true : false;

  const agreeEvent = () => {
    let newDate = new Date().getTime();
    setUserConsent(newDate);
  };
  const fetchData = () => {
    let data = {
      tnc_completed: true,
      tncChecked: userConsent,
    };
    dispatch(setUserSetting(data, successCallback, errorCallback));
  };

  useEffect(() => {
    if (userConsent !== null) {
      setShowPop(false);
      let data = {
        tnc_completed: true,
        tncChecked: userConsent,
      };
      dispatch(setUserSetting(data, successSettingCallback, errorSettingCallback));
    }
  }, [userConsent]);

  const cancelEvent = () => {
    setShowPop(false);
  };
  const successCallback = data => {
    setUserAgree(data);
  };
  const errorCallback = () => {};
  const successSettingCallback = response => {
    // setUserInfo(response);
  };
  const errorSettingCallback = () => {
    // setUserInfo(false);
  };

  const handleShowAgreement = () => {
    setLoyaltyAgreementFlag(!showLoyaltyAgreementFlag);
  };

  const successUnlinkedCallBack = data => {
    if (data.success) {
    }
  };

  const successCallbackGcc = resp => {};

  const errorCallbackGcc = err => {};

  const onKYCModalFooterClick = action => {
    switch (action?.type) {
      case 'OPEN_MODAL':
        updatePopupContent(popupInfo[action.name]);
        logPageLoadEvents('onboarding:signup:landing:kycupdate', {
          eVar15: 'onboarding:businessdetails|mypartner:kycupdate',
          channel: 'onboarding|mypartner:kycupdate',
          prop24: 'onboarding|mypartner:kycupdate',
          eVar24: 'onboarding|mypartner:kycupdate',
          prop27: '/agent/upload-license:kycupdate',
          eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
          prop54: 'myPartner_onboarding_kycupdate_open_click:kycupdate',
        });
        break;
      case 'CLOSE_MODAL':
        updatePopupContent(null);
        logPageLoadEvents('onboarding:signup:landing:kycupdate', {
          eVar15: 'onboarding:businessdetails|mypartner:kycupdate',
          channel: 'onboarding|mypartner:kycupdate',
          prop24: 'onboarding|mypartner:kycupdate',
          eVar24: 'onboarding|mypartner:kycupdate',
          prop27: '/agent/upload-license:kycupdate',
          eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
          prop54: 'myPartner_onboarding_kycupdate_close_click:kycupdate',
        });
        break;
      default:
        updatePopupContent(null);
    }
  };

  const handleSubmitLicenseVerificationSuccess = resp => {
    updatePopupContent(resp?.upload_status_popup[resp?.upload_status_popup?.defaultOpen?.name]);

    logPageLoadEvents('onboarding:signup:landing:kycupdate', {
      eVar15: 'onboarding:businessdetails|mypartner:kycupdate',
      channel: 'onboarding|mypartner:kycupdate',
      prop24: 'onboarding|mypartner:kycupdate',
      eVar24: 'onboarding|mypartner:kycupdate',
      prop27: '/agent/upload-license:kycupdate',
      eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
      prop54: 'myPartner_onboarding_LN_verification_true:kycupdate',
    });
  };

  const handleSubmitLicenseSuccess = resp => {
    logPageLoadEvents('onboarding:signup:landing:kycupdate', {
      eVar15: 'onboarding:businessdetails|mypartner:kycupdate',
      channel: 'onboarding|mypartner:kycupdate',
      prop24: 'onboarding|mypartner:kycupdate',
      eVar24: 'onboarding|mypartner:kycupdate',
      prop27: '/agent/upload-license:kycupdate',
      eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
      prop54: 'myPartner_onboarding_LN_verification_true:kycupdate',
    });

    if (resp?.data) {
      const obj = busineesDetails;
      for (const i in resp?.data) {
        obj[i] = resp.data[i];
      }
      setBusinessDetails(obj);
    }

    if (!resp?.is_editable) {
      setDisableSubmitButton(false);
    }
    if (resp?.manual_qc) {
      logPageLoadEvents('onboarding:signup:landing:kycupdate', {
        eVar15: 'onboarding:businessdetails|mypartner:kycupdate',
        channel: 'onboarding|mypartner:kycupdate',
        prop24: 'onboarding|mypartner:kycupdate',
        eVar24: 'onboarding|mypartner:kycupdate',
        prop27: '/agent/upload-license:kycupdate',
        eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
        prop54: 'manual_qc=true:kycupdate',
      });
    }
    updateDocUploadLoading(false);
    setResponseData(resp);
    setApprove(true);
    updateDocUploadErr({});
  };

  const handleSubmitLicenseErrorCallback = error => {
    logPageLoadEvents('onboarding:signup:landing:kycupdate', {
      eVar15: 'onboarding:businessdetails|mypartner:kycupdate',
      channel: 'onboarding|mypartner:kycupdate',
      prop24: 'onboarding|mypartner:kycupdate',
      eVar24: 'onboarding|mypartner:kycupdate',
      prop27: '/agent/upload-license:kycupdate',
      eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
      prop54: 'myPartner_onboarding_LN_verification_false:kycupdate',
    });
    updateDocUploadLoading(false);
    updateDisabledInputForDoc(false);
    if (error?.is_editable) {
      setResponseData(error);
      setApprove(true);
    }
    updateDocUploadErr(error);
    setTrnLoader(false);
  };

  const onDocApproveClick = () => {
    updateDocUploadLoading(true);
    updateDisabledInputForDoc(true);
    dispatch(
      submitLicenseDetails(
        {licence_number: licenseNumber, trading_license_doc: fileData},
        handleSubmitLicenseSuccess,
        handleSubmitLicenseErrorCallback,
      ),
    );

    logPageLoadEvents('onboarding:signup:landing:kycupdate', {
      eVar15: 'onboarding:businessdetails|mypartner:kycupdate',
      channel: 'onboarding|mypartner:kycupdate',
      prop24: 'onboarding|mypartner:kycupdate',
      eVar24: 'onboarding|mypartner:kycupdate',
      prop27: '/agent/upload-license:kycupdate',
      eVar37: 'domain_sbu:mypartner|domain_country:ae|domain_currency:aed|domain_language:eng',
      prop54: 'myPartner_onboarding_uploadApprove:kycupdate',
    });
  };

  const onDocUploadSubmit = () => {
    const token = docUploadResponse?.token || '';
    setTrnLoader(true);
    setTimeout(() => {}, 3000);
    if (!docUploadResponse?.is_editable) {
      if (!trnNumber)
        dispatch(
          submitLicenseDetails(
            {
              ...busineesDetails,
              licence_number: licenseNumber,
              trading_license_doc: fileData,
              token,
            },
            handleSubmitLicenseVerificationSuccess,
            handleSubmitLicenseErrorCallback,
          ),
        );
    } else {
      dispatch(
        submitLicenseDetails(
          {...busineesDetails, licence_number: licenseNumber, trading_license_doc: fileData, token},
          handleSubmitLicenseVerificationSuccess,
          handleSubmitLicenseErrorCallback,
        ),
      );
    }
  };

  return ccdeCookie !== 'AE' ? (
    <>
      <Helmet meta={[{name: 'robots', content: 'noindex, nofollow'}]} />
      {showLoyaltyAgreementFlag && <LoyalityAgreement />}
      <S.SettingsMainWrap>
        {/* <S.SettingsTopBack /> */}
        <Header />
        {indianUserFlag && (
          <S.SettingsInnerWrap>
            <LeftBlock userInfo={userData} />
            (
            <RightBlock
              userInfo={userData}
              supportInfo={supportDetails}
              handleAgreementClick={handleShowAgreement}
              ccdeCookie={ccdeCookie}
              fetchData={fetchData}
              sendTrackingDataToSdk={sendTrackingDataToSdk}
            />
            )
          </S.SettingsInnerWrap>
        )}
      </S.SettingsMainWrap>
      {showPop ? (
        <div>
          <S.PopOverlay />
          <PopUp
            cancelEvent={cancelEvent}
            agreeEvent={agreeEvent}
            termsMarkup={userAgree}
            policy={newPolicy}
          />{' '}
        </div>
      ) : null}
    </>
  ) : (
    <>
      <Helmet meta={[{name: 'robots', content: 'noindex, nofollow'}]} />

      <S.SettingsMainWrapGcc>
        {/* <S.SettingsTopBack> */}
        <Header />
        <S.SettingsInnerWrap>
          <LeftBlock userInfo={userData} />
          <RightBlockGcc
            onEditClick={action => {
              if (popupInfo && popupInfo[action?.name]) {
                updatePopupContent(popupInfo[action.name]);
              }
            }}
          />
        </S.SettingsInnerWrap>
        {/* </S.SettingsTopBack> */}
      </S.SettingsMainWrapGcc>

      {popupContent && popupContent?.component === 'INFO_POPUP' ? (
        <CommonModal modalWidth={540} closeModal={() => {}}>
          <KycExpiryModal data={popupContent?.data} footerCb={onKYCModalFooterClick} />
        </CommonModal>
      ) : null}

      {popupContent && popupContent?.component === 'TRADING_LICENCE_POPUP' ? (
        <PopUp1
          showPop={true}
          child={
            <DocUploadMpdal
              data={popupContent?.data}
              setFileData={setFileData}
              approveFileHandler={onDocApproveClick}
              isLoading={isDocUploadLoading}
              disabledInput={disabledInputForDoc}
              setDisabledInput={updateDisabledInputForDoc}
              setTrnNumber={setTrnNumber}
              licenseNumber={licenseNumber}
              setLicenseNumber={setLicenseNumber}
              approve={approve}
              responseData={docUploadResponse} // here need to pass the  api response on approval  click modal
              busineesDetails={busineesDetails}
              setBusinessDetails={setBusinessDetails}
              setApprove={setApprove}
              disableSubmitButton={disableSubmitButton}
              error={docUploadErr}
              onCloseIconClick={() => {
                updatePopupContent(null);
              }}
              onFormSubmit={onDocUploadSubmit}
              trnLoader={trnLoader}
              omniComponentName={':kycupdate'}
              allowPastDate={false}
            />
          }
          showBackButton={false}
        />
      ) : null}

      {popupContent && popupContent?.component === 'STATUS_POPUP' ? (
        <CommonModal modalWidth={540} closeModal={() => {}}>
          <StatusPopup
            data={popupContent?.data}
            onCloseIconClick={() => {
              updatePopupContent(null);
            }}
          />
        </CommonModal>
      ) : null}
    </>
  );
};

export default Settings;
